export default __webpack_public_path__ + "images/logoBioderma.36429c8006a16e8b4f1c221ba92cdbc6.svg"